
const anchorItems = document.querySelectorAll('.js-anchor')
const anchor = document.querySelector('.js-anchor-scroll')
const blockAnchor = document.querySelector('.js-anchor-wrap')

if (anchor) {
  let lastScrollTop = 0
  

  window.addEventListener('scroll', () => {
    const blockAnchorRect = blockAnchor.getBoundingClientRect()
    const offsetH = blockAnchorRect.height + blockAnchorRect.top

    const st = window.pageYOffset || document.documentElement.scrollTop  

    if (blockAnchorRect.top <= 0 && offsetH > 0) {
      anchor.classList.add('is-fixed')
    } else {
      anchor.classList.remove('is-fixed')
    }

    if (st > lastScrollTop) {
      anchor.classList.remove('is-fixed-bottom')
    } else {
      anchor.classList.add('is-fixed-bottom')
    }

    let lastActive = 0

    anchorItems.forEach((item, index) => {
      const hash = item.hash
      const elt = document.querySelector(hash)
      const eltRect = elt.getBoundingClientRect()
      let mobileH = window.innerWidth < 768 ? 80 : 120
      if (eltRect.top < mobileH) lastActive = index 
    })
    document.querySelector('.js-anchor.is-active').classList.remove('is-active')
    anchorItems[lastActive].classList.add('is-active')
    lastScrollTop = st <= 0 ? 0 : st
  })

  anchorItems.forEach((item, index) => {
    if (index === 0) item.classList.add('is-active')

    item.addEventListener('click', (e) => {
      let mobileH = window.innerWidth < 768 ? 80 : 120
      e.preventDefault()
      const hash = item.hash
      const elt = document.querySelector(hash)
      document.querySelector('.js-anchor.is-active').classList.remove('is-active')
      item.classList.add('is-active')

      window.scrollTo({
        top: elt.offsetTop - mobileH,
        behavior: 'smooth'
      })
    })
  });
}